import type { RefObject } from "react";
import { HideIcon } from "@icons";
import { Picker, type PickerItemData } from "@design-system/Picker/Picker.lib";
import styles from "./SlateEditor.module.scss";

type OrganizationScope = "internal" | "external";

const ORGANIZATION_SCOPE_ITEMS: ReadonlyArray<
    PickerItemData<OrganizationScope>
> = [
    { value: "internal", label: "Internal" },
    { value: "external", label: "External" },
];

const INTERNAL_SCOPE_LABEL = "Only visible to your firm";

const renderInternalScopeLabel = () => INTERNAL_SCOPE_LABEL;

/** The strip above an internal composer whose scope is fixed (a reply in an internal thread). */
export const OrganizationScopeLabel = () => (
    <div className={styles.organizationScopeLabel}>
        <HideIcon aria-hidden />
        {INTERNAL_SCOPE_LABEL}
    </div>
);

interface OrganizationScopePickerProps {
    /** The composer box the picker's popup anchors to. */
    attachedTo: RefObject<HTMLElement | null>;
    onIsInternalChange: (isInternal: boolean) => void;
}

/**
 * The strip above an internal composer: "Only visible to your firm", and the
 * trigger of the "Chat groups" picker that switches the message to External.
 */
export const OrganizationScopePicker = ({
    attachedTo,
    onIsInternalChange,
}: OrganizationScopePickerProps) => (
    <Picker.Select
        trigger="attached"
        attachedTo={attachedTo}
        title="Chat groups"
        icon={<HideIcon />}
        items={ORGANIZATION_SCOPE_ITEMS}
        value="internal"
        onValueChange={(scope) => {
            if (scope !== null) {
                onIsInternalChange(scope === "internal");
            }
        }}
        renderValue={renderInternalScopeLabel}
    />
);
